<template>
    <div class="root_page_center wrapper_loading">
        <div class="wp_loading">
            <div class="centerDivloading">
                <div class="text_logo">
                    <p class="pimg1"><img src="../assets/images/text.png" alt=""></p>
                    <p class="pimg2">
                        <img src="../assets/images/loading.gif" alt="">
                    </p>
                    <h4 class="titleProcess">Nhân viên đang xác thực</h4>
                </div>
                <div class="root_progress">
                    <div class="wp_process">
                        <div class="bg_process" :style="{ width: progress + '%' }"></div>
                    </div>
                    <p class="numberProcess">{{ Math.round(progress) }}%</p>
                </div>
            </div>
        </div>
        <img src="../assets/images/back.png" class="backpage" alt="" @click="backPage()">
        <!-- <div class="modalRedirect modal_register_success ld_overlay ld_stack_overlay" v-if="showmodal">
            <div class="content_modalredirect content_modalredirectHds ld_scroll ld_stack_item" :class="item.type" v-for="(item) in stack" :key="item.id">
                <p @click="closeStack(item.id)" class="closeMdredirect"><img src="../assets/images/close.png" alt=""></p>
                <div class="ld_scroll_area">
                    <div class="wrp_modal_type" v-if="item.type == 'thong_bao'">
                        <h6 v-html="item.content"></h6>
                        <div class="btnxn_modal">
                            <a @click="reloadPage()">Xác nhận</a>
                        </div>
                    </div>
                    <div class="wrp_modal_type" v-else-if="item.type == 'qr'">
                        <img :src="linkWebAdmin + item.qr" alt="" v-if="item.qr != null">
                        <h6 v-else>mã QR chưa cập nhật</h6>
                    </div>
                    <div class="wrp_modal_type" v-else>
                        <img src="../assets/images/dd.png" alt="">
                        <div class="btnxn_modal">
                            <router-link to="/identifier">{{ item.label }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import SocketIO from 'socket.io-client'
export default {
    name: 'Loading_tool',
    data() {
        return {
            token: window.localStorage.getItem('token'),
            progress: 0,
            totalProcess: 98,
            duration: 2000000,
            stepTime: 20000,
            intervalId: null,
            showmodal: false,
            types: [],
            dialog: null,
            qr: null,
            identify: '',
            socket: null,
            hiddenIds: [],
            orther: []
        }
    },
    components: {},
    computed: {
        modalItems() {
            const list = Array.isArray(this.types) ? this.types : []
            return list.map((t, index) => {
                if (t == 'thong_bao') {
                    return { id: index, type: 'thong_bao', label: 'Thông báo', content: (this.dialog && this.dialog.content) ? this.dialog.content : '' }
                }
                if (t == 'qr') {
                    return { id: index, type: 'qr', label: 'Mã QR', qr: (this.qr === undefined) ? null : this.qr }
                }
                return { id: index, type: 'dinh_danh', label: this.identify ? this.identify : 'Định danh' }
            })
        },
        stack() {
            return this.modalItems.filter(m => !this.hiddenIds.includes(m.id))
        }
    },
    mounted() {},
    created() {
        this.startProgress()
        this.getDataLD()
        this.socketEventLoad()
    },
    beforeUnmount() {
        clearInterval(this.intervalId);
        if (this.socket) {
            this.socket.disconnect()
        }
    },
    methods: {
        // startProgress() {
        //     const steps = this.duration / this.stepTime;
        //     const increment = this.totalProcess / steps;
        //     this.progress = 0;
        //     this.intervalId = setInterval(() => {
        //         if (this.progress >= this.totalProcess) {
        //             this.progress = this.totalProcess;
        //             clearInterval(this.intervalId);
        //             setTimeout(() => {
        //                 this.continueProgressTo100();
        //             }, 30 * 60 * 1000);
        //         } else {
        //             this.progress += increment;
        //             this.progress = Math.round(this.progress);
        //         }
        //     }, this.stepTime);
        // },
        // continueProgressTo100() {
        //     const duration = 1000;
        //     const stepTime = 100;
        //     const steps = duration / stepTime;
        //     const increment = (100 - this.progress) / steps;
        //     this.intervalId = setInterval(() => {
        //         this.progress += increment;
        //         if (this.progress >= 100) {
        //             this.progress = 100;
        //             clearInterval(this.intervalId);
        //             this.onProgressComplete();
        //         }
        //     }, stepTime);
        // },
        startProgress() {
            const originalDuration = this.duration;
            const originalStepTime = this.stepTime;
            const g1Total = 80; 
            const g1Duration = 5 * 60 * 1000; 
            const g1StepTime = 200;
            const steps = g1Duration / g1StepTime;
            const increment = g1Total / steps;
            this.progress = 0;
            this.intervalId = setInterval(() => {
                this.progress += increment; 
                if (this.progress >= g1Total) {
                    this.progress = g1Total;
                    clearInterval(this.intervalId);
                    this.continueProgressWithOriginalSpeed(originalDuration, originalStepTime);
                }
            }, g1StepTime);
        },
        continueProgressWithOriginalSpeed(originalDuration, originalStepTime) {
            const steps = originalDuration / originalStepTime;
            const increment = this.totalProcess / steps; 
            this.intervalId = setInterval(() => {
                this.progress += increment;
                if (this.progress >= 100) {
                    this.progress = 100;
                    clearInterval(this.intervalId);
                    this.onProgressComplete();
                }
            }, originalStepTime);
        },
        onProgressComplete() {
            this.$router.push('/')
        },
        getDataLD () {
            this.axios.get(this.api_loadIF,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                const data = (response.data && response.data.data) ? response.data.data : {}
                this.types = Array.isArray(data.types) ? data.types : []
                this.dialog = data.dialog ? data.dialog : null
                this.qr = (data.qr === undefined) ? null : data.qr
                this.identify = data.identify ? data.identify : ''
                this.showmodal = this.types.length > 0
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        socketEventLoad () {
            let thiss = this
            let idUser = window.localStorage.getItem('idUser')
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_loading.${idUser}:LoadingEvent`, function(result) {
                if(result.data.types.length > 0){
                    thiss.orther = result
                    thiss.$router.push('/identifier');
                }
            });
        },
        reloadPage () {
            this.showmodal = false
            this.hiddenIds = []
            this.startProgress()
        },
        closeStack (itemId) {
            if (itemId == null || this.modalItems.length === 0) return
            if (!this.hiddenIds.includes(itemId)) this.hiddenIds.push(itemId)
            if (this.hiddenIds.length >= this.modalItems.length) {
                this.showmodal = false
                this.hiddenIds = []
            }
        },
        backPage () {
            this.$router.back(); 
        }
    }
}
</script>

<style>
.modal_register_success.ld_stack_overlay {
	display: grid;
	grid-template-columns: minmax(0, 1fr);
	place-items: center;
	align-content: center;
}
.modal_register_success .content_modalredirect.ld_scroll {
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	max-height: 90vh;
}
.modal_register_success .content_modalredirect.ld_stack_item {
	grid-area: 1 / 1;
	width: calc(100% - 32px);
	max-width: 420px;
	margin: 0;
}
.modal_register_success .content_modalredirect.ld_stack_item.thong_bao{
	transform: translate(0, 0px);
    z-index: 3;
}
.modal_register_success .content_modalredirect.ld_stack_item.qr{
    transform: translate(0, 68px);
    z-index: 2;
}
.modal_register_success .content_modalredirect.ld_stack_item.dinh_danh{
    transform: translate(0, -31px);
    z-index: 1;
}
.ld_scroll_area {
	flex: 1 1 auto;
	min-height: 0;
	overflow-y: auto;
	overflow-x: hidden;
	-webkit-overflow-scrolling: touch;
	overscroll-behavior: contain;
	padding: 2px 10px 2px 2px;
}
.ld_scroll_area::-webkit-scrollbar {
	width: 8px;
}
.ld_scroll_area::-webkit-scrollbar-track {
	background: transparent;
	border-radius: 8px;
}
.ld_scroll_area::-webkit-scrollbar-thumb {
	background: #cdd2d8;
	border-radius: 8px;
}
.ld_scroll_area::-webkit-scrollbar-thumb:hover {
	background: #aeb5bd;
}
.ld_step {
	position: absolute;
	top: 14px;
	left: 14px;
	z-index: 3;
	margin: 0;
	padding: 4px 12px;
	background: rgba(0, 146, 82, .1);
	border: 1px solid rgba(0, 146, 82, .3);
	border-radius: 999px;
	color: #009252;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 12px;
	font-weight: 700;
	line-height: 1;
}
.ld_stack_item .wrp_modal_type img {
	max-width: 100%;
	height: auto;
}
@media (max-width: 768px) {
	.ld_stack_item .wrp_modal_type img {
		max-height: 40vh;
		object-fit: contain;
	}
}
@media (max-width: 480px) {
	.modal_register_success.ld_stack_overlay {
		padding: 12px;
	}
	.modal_register_success .content_modalredirect.ld_stack_item {
		width: calc(100% - 24px);
	}
	.ld_step {
		top: 12px;
		left: 12px;
		padding: 3px 8px;
		font-size: 11px;
	}
}
</style>
